/**
 * Drag-to-create on the Timeline: a drag across empty cells of a vehicle lane
 * becomes the pre-filled "new booking" screen. The pure parts live here: the
 * ordered selection, and the navigation target that screen reads.
 */
import { romeNow } from '../time'

/** The route the selection opens: the existing new-booking screen. */
export const CREATE_ROUTE = '/bookings/new'

/** What the new-booking screen reads from its search: Rome wall-clock, like its own fields. */
export interface CreateSearch {
  category: string
  vehicle: string
  pickupDate: string
  pickupTime: string
  returnDate: string
  returnTime: string
}

export interface CreateTarget {
  to: typeof CREATE_ROUTE
  search: CreateSearch
}

export interface CreateInput {
  categoryId: string
  vehicleId: string
  startsAt: Date
  endsAt: Date
}

/** The `[start, end)` between two snapped instants, whichever way it was dragged; null when empty. */
export function selectionRange(
  anchor: Date,
  current: Date,
): { startsAt: Date; endsAt: Date } | null {
  if (anchor.getTime() === current.getTime()) return null
  return anchor.getTime() < current.getTime()
    ? { startsAt: anchor, endsAt: current }
    : { startsAt: current, endsAt: anchor }
}

/** Where a finished selection navigates: the vehicle, its category and the Rome dates and times. */
export function createTarget(input: CreateInput): CreateTarget {
  const start = romeNow(input.startsAt)
  const end = romeNow(input.endsAt)
  return {
    to: CREATE_ROUTE,
    search: {
      category: input.categoryId,
      vehicle: input.vehicleId,
      pickupDate: start.date,
      pickupTime: start.time,
      returnDate: end.date,
      returnTime: end.time,
    },
  }
}
